import { useState } from 'react';
import { StateSnapshot } from 'react-virtuoso';
import useSnapshotController from '../../hooks/SnapshotController/useSnapshotController';
import {
  CatalogProductsListV2Result,
  UseCatalogProductsListV2Params,
} from '../catalogProductsListV2.types';
import { useCatalogView } from '../contexts/CatalogView.context';
import { useCatalogCollectionSource } from './useCatalogCollectionSource';
import { useProductCollectionList } from './useProductCollectionList';

export const useCatalogProductsListV2 = (
  params: UseCatalogProductsListV2Params,
): CatalogProductsListV2Result => {
  const { catalogId, maxItemsPerRow, pageSize, isOfflineMode, canPersist } = params;

  const { effectiveMode } = useCatalogView();
  const { getSnapshot } = useSnapshotController<StateSnapshot>({
    isOfflineMode,
    mode: effectiveMode,
  });

  const [anchorPage, setAnchorPage] = useState(0);

  const source = useCatalogCollectionSource({
    catalogId,
    anchorPage,
    pageSize,
    isOfflineMode,
    canPersist,
  });

  return useProductCollectionList({
    collectionId: catalogId,
    source,
    anchorPage,
    maxItemsPerRow,
    pageSize,
    isOfflineMode,
    getSnapshot,
    onAnchorPageChange: setAnchorPage,
  });
};
